export const convertToObject = (value) => {
    if (Array.isArray(value)) {
        return value.map(convertToObject);
    }
    else if (value instanceof Map) {
        return Object.fromEntries(Array.from(value.entries(), ([k, v]) => [k, convertToObject(v)]));
    }
    return value;
};
//# sourceMappingURL=util.js.map